import { createSlice } from "@reduxjs/toolkit";
import {
  createRoomCategory,
  deleteRoomCategory,
  deleteUndoRoomCategory,
  fetchOneRoomCategory,
  fetchRoomCategory,
  updateRoomCategory,
} from "./roomCategoryThunks";

const initialState = {
  data: [],
  oneRoomCategory: null,
  totalPages: 1,
  totalItems: 0,
  loading: false,
  error: null,
};

const hotelRoomCategorySlice = createSlice({
  name: "hotelRoomCategory",
  initialState,

  extraReducers: (builder) => {
    builder
      // get All Hotel Room Category
      .addCase(fetchRoomCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoomCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchRoomCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOneRoomCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOneRoomCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.oneRoomCategory = action.payload;
      })
      .addCase(fetchOneRoomCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create Hotel Room Category
      .addCase(createRoomCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRoomCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.data.push(action.payload);
      })
      .addCase(createRoomCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Hotel Room Category
      .addCase(updateRoomCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRoomCategory.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(updateRoomCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Hotel Room Category
      .addCase(deleteRoomCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRoomCategory.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload
        );
        if (index !== -1) {
          state.data[index].status = "deleted";
        }
      })
      .addCase(deleteRoomCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Undo Delete Hotel Room Category
      .addCase(deleteUndoRoomCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUndoRoomCategory.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload
        );
        if (index !== -1) {
          state.data[index].status = "activate";
        }
      })
      .addCase(deleteUndoRoomCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default hotelRoomCategorySlice.reducer;
